.layout {
  display: grid;
  gap: clamp(2rem, 5vw, 3.5rem);
  align-items: start;
}

@media (min-width: 52rem) {
  .layout {
    grid-template-columns: minmax(15rem, 20rem) 1fr;
  }

  /* Sticks alongside the prose on wide screens. */
  .portraitWrap {
    position: sticky;
    top: 6rem;
  }
}

.figure {
  margin: 0;
}

.portrait {
  width: 100%;
  height: auto;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  object-position: center 20%;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background-color: var(--bg-elev-2);
  box-shadow: var(--shadow-lg);
}

.caption {
  margin-top: 0.9rem;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.06em;
  color: var(--text-faint);
}

.prose {
  display: grid;
  gap: 1.35rem;
  max-width: 62ch;
  color: var(--text-dim);
}

.prose p {
  font-size: var(--step-0);
}

/* Two classes outrank `.prose p`, so the lead paragraph wins without !important. */
.prose .first {
  font-size: var(--step-1);
  color: var(--text);
}
